// Easy Responsive Tabs Plugin
// Author: Samson.Onna <Email : samson3d@gmail.com>
(function ($) {
    $.fn.extend({
        easyResponsiveTabs: function (options) {
            //Set the default values, use comma to separate the settings, example:
            var defaults = {
                type: 'default', //default, vertical, accordion;
                width: 'auto',
                fit: true,
                closed: false,
                tabidentify: '',
                activetab_bg: 'transparent',
                inactive_bg: 'transparent',
                active_border_color: 'transparent',
                active_content_border_color: 'transparent',
                activate: function () {
                }
            }
            //Variables
            var options = $.extend(defaults, options);
            var opt = options, jtype = opt.type, jfit = opt.fit, jwidth = opt.width, vtabs = 'vertical', accord = 'accordion';
            var hash = window.location.hash;
            var historyApi = !!(window.history && history.replaceState);

            //Events
            $(this).bind('tabactivate', function (e, currentTab) {
                if (typeof options.activate === 'function') {
                    options.activate.call(currentTab, e)
                }
            });

            //Main function
            this.each(function () {
                var $respTabs = $(this);
                var $respTabsList = $respTabs.find('ul.resp-tabs-list.' + options.tabidentify);
                var respTabsId = $respTabs.attr('id');
                $respTabs.find('ul.resp-tabs-list.' + options.tabidentify + ' li').addClass('resp-tab-item').addClass(options.tabidentify);
                $respTabs.css({
                    'display': 'block',
                    'width': jwidth
                });
                if (options.type == 'vertical')
                    $respTabsList.css('margin-top', '3px');

                $respTabs.find('.resp-tabs-container.' + options.tabidentify);
                $respTabs.find('.resp-tabs-container.' + options.tabidentify + ' > div').addClass('resp-tab-content').addClass(options.tabidentify);
                jtab_options();
                //Properties Function
                function jtab_options() {
                    if (jtype == vtabs) {
                        $respTabs.addClass('resp-vtabs').addClass(options.tabidentify);
                    }
                    if (jfit == true) {
                        $respTabs.css({ width: '100%', margin: '0px' });
                    }
                    if (jtype == accord) {
                        $respTabs.addClass('resp-easy-accordion').addClass(options.tabidentify);
                        $respTabs.find('.resp-tabs-list').css('display', 'none');
                    }
                }

                //Assigning the h2 markup to accordion title
                var $tabItemh2;
                $respTabs.find('.resp-tab-content.' + options.tabidentify).before("<h2 class='resp-accordion " + options.tabidentify + "' role='tab'><span class='resp-arrow'></span></h2>");

                $respTabs.find('.resp-tab-content.' + options.tabidentify).prev("h2");

                var itemCount = 0;
                $respTabs.find('.resp-accordion').each(function () {
                    $tabItemh2 = $(this);
                    var $tabItem = $respTabs.find('.resp-tab-item:eq(' + itemCount + ')');
                    var $accItem = $respTabs.find('.resp-accordion:eq(' + itemCount + ')');
                    $accItem.append($tabItem.html());
                    $accItem.data($tabItem.data());
                    // Preserve existing tabpanel wiring when present
                    var existingAccControls = $tabItemh2.attr('aria-controls');
                    if (!existingAccControls) {
                        $tabItemh2.attr('aria-controls', options.tabidentify + '_tab_item-' + (itemCount));
                    }
                    itemCount++;
                });

                // Wrap accordion elements in a tablist container for ADA compliance
                // Elements with role="tab" must be contained by role="tablist"
                var $accordionContainer = $respTabs.find('.resp-tabs-container.' + options.tabidentify);
                var $accordions = $accordionContainer.find('.resp-accordion.' + options.tabidentify);
                if ($accordions.length > 0) {
                    // Check if container already has role="tablist"
                    if (!$accordionContainer.attr('role') || $accordionContainer.attr('role') !== 'tablist') {
                        // Since accordions are interleaved with content divs, we'll wrap all accordions
                        // together in a single tablist container
                        // Collect all accordions first
                        var $accordionList = $('<div class="resp-accordion-list" role="tablist"></div>');

                        // Insert the tablist before the first accordion
                        $accordions.first().before($accordionList);

                        // Move all accordions into the tablist
                        $accordions.each(function() {
                            $accordionList.append($(this));
                        });
                    }
                }

                //Assigning the 'aria-controls' to Tab items
                var count = 0,
                    $tabContent;
                $respTabs.find('.resp-tab-item').each(function () {
                    $tabItem = $(this);
                    // If theme markup already provides aria-controls + ids, don't overwrite.
                    var panelId = $tabItem.attr('aria-controls') || (options.tabidentify + '_tab_item-' + (count));
                    $tabItem.attr('aria-controls', panelId);
                    $tabItem.attr('role', 'tab');

                    // Assign ids/roles to tab panels WITHOUT breaking ARIA spec:
                    // - Panel id should match tab's aria-controls
                    // - Panel aria-labelledby should point to tab id (if present)
                    $tabContent = $respTabs.find('.resp-tab-content.' + options.tabidentify + ':eq(' + count + ')');
                    if ($tabContent.length) {
                        if (!$tabContent.attr('id')) {
                            $tabContent.attr('id', panelId);
                        }
                        if (!$tabContent.attr('role')) {
                            $tabContent.attr('role', 'tabpanel');
                        }
                        var tabId = $tabItem.attr('id');
                        if (tabId && !$tabContent.attr('aria-labelledby')) {
                            $tabContent.attr('aria-labelledby', tabId);
                        }
                    }
                    count++;
                });

                // Show correct content area
                var tabNum = 0;
                if (hash != '') {
                    var matches = hash.match(new RegExp(respTabsId + "([0-9]+)"));
                    if (matches !== null && matches.length === 2) {
                        tabNum = parseInt(matches[1], 10) - 1;
                        if (tabNum > count) {
                            tabNum = 0;
                        }
                    }
                }

                //Active correct tab
                $($respTabs.find('.resp-tab-item.' + options.tabidentify)[tabNum]).addClass('resp-tab-active');

                if (options.closed !== true && !(options.closed !== 'accordion' && !$respTabsList.is(':visible')) && !(options.closed === 'tabs' && $respTabsList.is(':visible'))) {
                    $($respTabs.find('.resp-accordion.' + options.tabidentify)[tabNum]).addClass('resp-tab-active');

                    $($respTabs.find('.resp-tab-content.' + options.tabidentify)[tabNum]).addClass('resp-tab-content-active').addClass(options.tabidentify).attr('style', 'display:block');
                }

                //assign proper classes for when tabs mode is activated before making a selection in accordion mode
                else {
                    // $($respTabs.find('.resp-tab-content.' + options.tabidentify)[tabNum]).addClass('resp-accordion-closed'); //removed resp-tab-content-active
                }

                //Tab Click action function
                $respTabs.find("[role=tab]").each(function () {

                    var $currentTab = $(this);
                    $currentTab.click(function () {

                        var $currentTab = $(this);
                        var $tabAria = $currentTab.attr('aria-controls');

                        if ($currentTab.hasClass('resp-accordion') && $currentTab.hasClass('resp-tab-active')) {
                            $respTabs.find('.resp-tab-content-active.' + options.tabidentify).addClass('resp-accordion-closed');
                            $currentTab.removeClass('resp-tab-active');
                            return false;
                        }
                        if (!$currentTab.hasClass('resp-tab-active') && $currentTab.hasClass('resp-accordion')) {
                            $respTabs.find('.resp-tab-active.' + options.tabidentify).removeClass('resp-tab-active');
                            $respTabs.find('.resp-tab-content-active.' + options.tabidentify).removeClass('resp-tab-content-active resp-accordion-closed');
                            $respTabs.find("[aria-controls=" + $tabAria + "]").addClass('resp-tab-active');

                            // Prefer ARIA-correct mapping: aria-controls points to panel id
                            $respTabs.find('#' + $tabAria + '.resp-tab-content.' + options.tabidentify).addClass('resp-tab-content-active');
                        } else {
                            $respTabs.find('.resp-tab-active.' + options.tabidentify).removeClass('resp-tab-active');

                            $respTabs.find('.resp-tab-content-active.' + options.tabidentify).removeAttr('style').removeClass('resp-tab-content-active').removeClass('resp-accordion-closed');

                            $respTabs.find("[aria-controls=" + $tabAria + "]").addClass('resp-tab-active');

                            // Prefer ARIA-correct mapping: aria-controls points to panel id
                            $respTabs.find('#' + $tabAria + '.resp-tab-content.' + options.tabidentify).addClass('resp-tab-content-active').attr('style', 'display:block');
                        }
                        //Trigger tab activation event
                        $currentTab.trigger('tabactivate', $currentTab);

                        //Update Browser History
                        if (historyApi) {
                            var currentHash = window.location.hash;
                            var tabAriaParts = $tabAria.split('tab_item-');
                            // var newHash = respTabsId + (parseInt($tabAria.substring(9), 10) + 1).toString();
                            var newHash = "";
                            if (currentHash != "") {
                                var re = new RegExp(respTabsId + "[0-9]+");
                                if (currentHash.match(re) != null) {
                                    newHash = currentHash.replace(re, newHash);
                                }
                                else {
                                    newHash = currentHash + "|" + newHash;
                                }
                            }
                            else {
                                newHash = "";
                            }

                            history.replaceState(null, null, newHash);
                        }
                    });

                });

                //Window resize function
                $(window).resize(function () {
                    $respTabs.find('.resp-accordion-closed').removeAttr('style');
                });
            });
        }
    });
})(jQuery);

